import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { DialogueData } from '../../../../general/Dialogue';
import { CharacterDialogue } from '../../../../general/Character';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { SortingData } from '../..';
import { t } from 'ttag';
import { ZookeeperLeanne } from '../../characters/Zookeepers';

const TuringOutro: React.FC<ISlide<SortingData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: ZookeeperLeanne,
            text: t`Thanks so much ${data.name}. We can’t sort our animals into the right pens. I think we have too many...`,
            buttonText: t`Next`,
        },
        {
            character: ZookeeperLeanne,
            text: t`By mistake we put a goat in the pig pen last week... Luckily we have the whole family here to help, let's say hello to them!`,
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default TuringOutro;
